import React from 'react';
import { fromStorage } from '../../../utils';
import { Onboarding1 } from '../../../assets/img';
import { ChevronRightIcon, EyeIcon } from '../../../assets/icons';

class Onboarding extends React.Component {

  skip = () => {
		this.props.history.replace('/');
  }

  downloadPrintable = () => {
    const link = document.createElement('a');
    link.href = fromStorage('know_more.pdf');
    link.download = 'Conocer Más.pdf';
    link.target = '_blank';
    link.click();
    link.remove();
  }

  render() {
    return (
      <div className="max-w-[400px] mx-auto my-8 flex flex-col gap-4">
        <div className="flex-1 flex flex-col items-center">
          <img src={Onboarding1} className="max-w-[300px] object-contain p-2" alt="" />
          <button
            className="border-t border-b border-gray6 flex justify-between items-center gap-2 px-5 py-3 w-full mt-8"
            onClick={this.downloadPrintable}
          >
            <img src={EyeIcon} className="w-6 h-6 object-contain" alt="" />
            <p className="text-lg font-semibold flex-1">Conoce nuestros productos</p>
            <img src={ChevronRightIcon} className="w-4 h-4 object-contain" alt="" />
          </button>
        </div>

        <button
          className="rounded-lg w-full text-center h-10 font-bold text-lg my-2 bg-green text-white"
          onClick={() => this.skip()}
        >
          <span>Omitir</span>
        </button>
      </div>
    )
  }
}

export default Onboarding